import React, { useContext } from "react";
import { useState, useEffect } from "react";
import ButtonSubmit from "../buttonSubmit";
import {
  CONST_GENDER_FEMALE,
  CONST_GENDER_MALE,
  isValidGender,
  simplyClick,
} from "../../helpers";

import "./GenderForm.scss";
import { ContextProfileUser } from "../../lib/profileContext";
import ProgressDots from "../ProgressDots";

function GenderForm({ nextStep }) {
  const [errorGender, setErrorGender] = useState(null);
  const genderLabel = {
    [CONST_GENDER_MALE]: "Man, looking for a woman",
    [CONST_GENDER_FEMALE]: "Woman, looking for a man",
  };
  const genderTextMap = {
    [CONST_GENDER_MALE]: "male",
    [CONST_GENDER_FEMALE]: "female",
  };
  const { data, setData } = useContext(ContextProfileUser);

  const handlerSubmit = (event) => {
    event.preventDefault();
    if (!isValidGender(data.gender)) {
      setErrorGender("Please, choose your gender ");
    } else {
      simplyClick("cl_lnd_i_am_next");
      nextStep();
    }
  };

  const [choiceGender, setChoiceGender] = useState(CONST_GENDER_MALE);

  const handleAddTypeGender = (e) => {
    const value = e.target.value.toString();

    setData({ ...data, gender: value });
    setChoiceGender(value);
    simplyClick("cl_lnd_i_am_choose", { text: genderTextMap[value] });
  };

  useEffect(() => {
    setData({ ...data, gender: CONST_GENDER_MALE });
  }, []);

  const options = [];

  Object.keys(genderLabel).forEach((key, index) => {
    options.push(
      <option value={key} key={`${key}_${index}`}>
        {genderLabel[key]}
      </option>,
    );
  });

  return (
    <div className="promo__wrapper-gender">
      <form className="gender__form" onSubmit={handlerSubmit}>
        <div className="user__form-top">
          <h3>I am a</h3>
        </div>
        <div className="gender__form-content">
          <div className="custom-select gender">
            <div className="custom-select-me">
              <select
                onChange={(e) => handleAddTypeGender(e)}
                className="gender"
                value={choiceGender}
              >
                {options}
              </select>
            </div>
          </div>
          {errorGender && <p className="error">{errorGender}</p>}
          <ButtonSubmit
            className={"button__global button__gender"}
            text={"NEXT"}
          />
          
          <ProgressDots active={2} />
        </div>
      </form>
    </div>
  );
}

export default GenderForm;
